import IThresholdDataRepository from '../infractructure/repositories/iThresholdDataRepository';
import ThresholdDataRepository from '../infractructure/repositories/thresholdDataRepository';

class SetDLZDataService {
  private readonly _jitRepository: IThresholdDataRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute(queryParams: { dlz: number; threshold_capacity: string }) {
    return this._jitRepository
      .setDLZ(queryParams)
      .then((res) => res)
      .catch((error: any) => {
        // Si es 404, devolver lista vacía
        if (error.message === 'Error: 404') {
          return [];
        }

        // Propagar otros errores
        throw error;
      });
  }
}

export default new SetDLZDataService({ repository: ThresholdDataRepository });

export { SetDLZDataService };
